import toast from "react-hot-toast";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const errorMsg = err.response?.data?.message || err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				id: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				id: errorMsg,
			});
		}
	} else {
		toast.error("An error occurred!");
	}
};

export default toastError;
